module.exports = __webpack_public_path__ + "img/planeta-3.4ebcf761.png";